// Used in login-routing.module.ts

// Angular
import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";

// RXJS/Store
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as fromStore from "../../store";

// Services/Types/Helpers
// Validators
import { EmailValidator } from "#validators/email.validator";
import { Auth, ForgetPwdRequest, UsersService } from "@carnegie-learning/data-access-angular-passport";

@Component({
    selector: "app-login-forgot-pwd",
    templateUrl: "./login-forgot-pwd.component.html",
    styleUrls: ["./login-forgot-pwd.component.scss"],
    standalone: false
})
export class LoginForgotPwdComponent implements OnInit, OnDestroy {
    emailControl = new UntypedFormControl("", {
        validators: [Validators.required, EmailValidator.email],
        updateOn: "change",
    });
    errors: any;
    formFlag = true;
    sendingFlag = false;
    private ngUnsubscribe = new Subject();

    constructor(
        private router: Router,
        public store: Store<fromStore.UserState>,
        public auth: Auth,
        private usersService: UsersService
    ) {}

    ngOnInit() {}

    validate(type: string) {
        return this.emailControl.touched && this.emailControl.hasError(type);
    }

    goBack() {
        return this.router.navigate(["login/form"]);
    }

    submit(): void {
        const payload: ForgetPwdRequest = {
            email: this.emailControl.value,
        };

        this.sendingFlag = true;
        this.formFlag = false;

        this.usersService
            .forgetPassword(payload)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (response) => {
                    this.sendingFlag = false;
                },
                (error) => {
                    if (error.status !== 404) {
                        this.errors = error;
                    }
                    this.sendingFlag = false;
                }
            );
    }

    // Remove whitespace from login email
    removeWhitespace(event: KeyboardEvent) {
        const email = this.emailControl.value.trim();
        this.emailControl.patchValue(email.trim());
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
